import { Link } from "wouter";
import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AgentsHubPanel } from "@/components/agents/AgentsHubPanel";

export default function AiAgentsHub() {
  return (
    <div className="p-6 max-w-6xl mx-auto">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
        <div>
          <h1 className="text-3xl font-bold" data-testid="text-page-title">
            AI Agents
          </h1>
          <p className="text-muted-foreground mt-1">
            Build specialists with instructions, skills, knowledge, and workflow automation
          </p>
        </div>
        <Link href="/ai-agents/skills">
          <Button variant="outline">
            <Sparkles className="h-4 w-4 mr-2" />
            Manage Skills
          </Button>
        </Link>
      </div>
      <AgentsHubPanel />
    </div>
  );
}
